export const CATEGORIES = [
  { id: "vehicles", labelKey: "vehicles" },
  { id: "services", labelKey: "services" },
  { id: "invoices", labelKey: "invoices" },
  { id: "deliveryNotes", labelKey: "deliveryNotes" },
  { id: "savings", labelKey: "fleetBotSavings" },
  { id: "customInquiry", labelKey: "fleetBotCustomInquiry", isForm: true },
];

export const QUESTIONS = {
  vehicles: [
    { id: "totalVehicles", labelKey: "fleetBotTotalVehicles" },
    { id: "servedVehicles", labelKey: "fleetBotServedVehicles" },
    { id: "vehicleDetails", labelKey: "fleetBotVehicleDetails", needsVehicle: true },
    { id: "mileageSummary", labelKey: "fleetBotMileageSummary" },
  ],
  services: [
    { id: "servicesThisMonth", labelKey: "fleetBotServicesThisMonth" },
    { id: "upcomingServices", labelKey: "fleetBotUpcomingServices" },
    { id: "overdueServices", labelKey: "fleetBotOverdueServices" },
    { id: "serviceHistory", labelKey: "fleetBotServiceHistory" },
  ],
  invoices: [
    { id: "invoicesCurrentMonth", labelKey: "fleetBotCurrentMonth" },
    { id: "invoicesLastMonth", labelKey: "fleetBotLastMonth" },
    { id: "pendingInvoices", labelKey: "fleetBotPendingInvoices" },
    { id: "invoiceSummary", labelKey: "fleetBotInvoiceSummary" },
  ],
  deliveryNotes: [
    { id: "dnCurrentMonth", labelKey: "fleetBotCurrentMonth" },
    { id: "dnLastMonth", labelKey: "fleetBotLastMonth" },
    { id: "pendingDeliveryNotes", labelKey: "fleetBotPendingDeliveryNotes" },
    { id: "deliveryNoteSummary", labelKey: "fleetBotDeliveryNoteSummary" },
  ],
  savings: [
    { id: "totalSavings", labelKey: "fleetBotTotalSavings" },
    { id: "savingsThisMonth", labelKey: "fleetBotSavingsThisMonth" },
    { id: "marketPriceVsSpent", labelKey: "fleetBotMarketPriceVsSpent" },
    { id: "savingsByVehicle", labelKey: "fleetBotSavingsByVehicle" },
  ],
};

export const PROMPTS = {
  welcome: "fleetBotHowMayIHelp",
  categories: "fleetBotChooseCategory",
  vehicles: "fleetBotVehiclesPrompt",
  services: "fleetBotServicesPrompt",
  invoices: "fleetBotInvoicesPrompt",
  deliveryNotes: "fleetBotDeliveryNotesPrompt",
  savings: "fleetBotSavingsPrompt",
  vehiclePicker: "fleetBotSelectVehicle",
  customInquiry: "fleetBotCustomInquiryPrompt",
};

export const COMING_SOON_QUESTION_IDS = new Set(
  Object.values(QUESTIONS)
    .flat()
    .filter((item) => item.comingSoon)
    .map((item) => item.id)
);
